import {
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Theme,
} from "@fluentui/react-components";
import { State, TranactionState, TransactionReport } from "../../KulcsUzletSvc";
import { formatDate } from "../../utils/HelperFunctions";

export const columnSizingOptionsTransactions = {
  customerCode: {
    minWidth: 100,
    defaultWidth: 150,
  },
  paymentUserEmail: {
    minWidth: 100,
    defaultWidth: 200,
  },
  state: {
    minWidth: 100,
    defaultWidth: 150,
  },
  transactionId: {
    minWidth: 100,
    defaultWidth: 150,
  },
  transactionState: {
    minWidth: 100,
    defaultWidth: 150,
  },
  rowVersion: {
    minWidth: 100,
    defaultWidth: 150,
  },
  expiredDate: {
    minWidth: 100,
    defaultWidth: 150,
  },
  amount: {
    minWidth: 100,
    defaultWidth: 150,
  },
  discount: {
    minWidth: 100,
    defaultWidth: 150,
  },
  responseCode: {
    minWidth: 100,
    defaultWidth: 150,
  },
};

const getStateStyle = (
  value?: State | TranactionState
): React.CSSProperties => {
  return {};
  // switch (value) {
  //   case "ACTIVE":
  //   case "INVOICED":
  //   case "FINISHED":
  //   case "FREE":
  //   case "INVOICE_CREATED":
  //     return {
  //       backgroundColor: "#22c55e",
  //       color: "white",
  //       padding: "2px 6px",
  //       borderRadius: "4px",
  //     }; // green
  //   case "TRIAL":
  //   case "STARTED":
  //   case "PENDING":
  //   case "INACTIVE":
  //   case "INVOICE_CREATING":
  //   case "INVOICE_PROCESSING":
  //   case "UNDER_PAYMENT":
  //     return {
  //       backgroundColor: "#facc15",
  //       color: "black",
  //       padding: "2px 6px",
  //       borderRadius: "4px",
  //     }; // yellow
  //   case "FORCECLOSED":
  //     return {
  //       backgroundColor: "#f97316",
  //       color: "white",
  //       padding: "2px 6px",
  //       borderRadius: "4px",
  //     }; // orange
  //   case "FAILED":
  //   case "RENEWAL_ERROR":
  //     return {
  //       backgroundColor: "#ef4444",
  //       color: "white",
  //       padding: "2px 6px",
  //       borderRadius: "4px",
  //     }; // red
  //   case "UNSUBSRIBE":
  //     return {
  //       backgroundColor: "#ecef44ff",
  //       padding: "2px 6px",
  //       borderRadius: "4px",
  //     }; // red
  //   default:
  //     return {
  //       backgroundColor: "#e5e7eb",
  //       color: "black",
  //       padding: "2px 6px",
  //       borderRadius: "4px",
  //     }; // gray
  // }
};

export const getColumnsTransactions = (theme: Theme) =>
  [
    createTableColumn<TransactionReport>({
      columnId: "customerCode",
      renderHeaderCell: () => "Partner kód",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>{item.customerCode ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "paymentUserEmail",
      renderHeaderCell: () => "Regisztrációs email",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>
            {item.paymentUserEmail ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "state",
      renderHeaderCell: () => "Státusz",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>
            <span style={getStateStyle(item.state)}>{item.state ?? ""}</span>
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),

    createTableColumn<TransactionReport>({
      columnId: "transactionId",
      renderHeaderCell: () => "Tranzakció id",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>
            <a href={`/admin/transactions/${item.transactionId}`}>
              {item.transactionId ?? ""}
            </a>
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "transactionState",
      renderHeaderCell: () => "Tranzakció státusz",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>
            <span style={getStateStyle(item.transactionState)}>
              {item.transactionState ?? ""}{" "}
            </span>
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "rowVersion",
      renderHeaderCell: () => "Tranzakció dátum",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>
            {formatDate(item.rowVersion)}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "expiredDate",
      renderHeaderCell: () => "Aktív eddig",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>
            {formatDate(item.expiredDate) ?? ""}
          </TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "amount",
      renderHeaderCell: () => "Összeg",
      renderCell: (item: TransactionReport) => {
        return <TableCellLayout truncate>{item.amount ?? ""}</TableCellLayout>;
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "discount",
      renderHeaderCell: () => "Kedvezmény (%)",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>{item.discount ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
    createTableColumn<TransactionReport>({
      columnId: "responseCode",
      renderHeaderCell: () => "RC",
      renderCell: (item: TransactionReport) => {
        return (
          <TableCellLayout truncate>{item.responseCode ?? ""}</TableCellLayout>
        );
      },
    } as TableColumnDefinition<TransactionReport>),
  ] as TableColumnDefinition<TransactionReport>[];
